import { clientsConstants } from "../constants/action.constants";

const initialState = {
  fetching: false,
  fetched: false,
  request: null,
  response: null,
  error: null
};

export const viewClient = (state = initialState, action) => {
  switch (action.type) {
    case clientsConstants.VIEW_CLIENT_REQUEST:
      return {
        ...state,
        fetching: true,
        fetched: false,
        request: action.id,
        response: null,
        error: null
      };
    case clientsConstants.VIEW_CLIENT_SUCCESS:
      return {
        ...state,
        fetching: false,
        fetched: true,
        response: action.response,
        error: null
      };
    case clientsConstants.VIEW_CLIENT_FAILURE:
      return {
        ...state,
        fetching: false,
        fetched: false,
        response: null,
        error: action.error
      };
    case clientsConstants.VIEW_CLIENT_RESET:
      return {
        ...state,
        ...initialState
      };
    default:
      return state;
  }
};
